import React, { useState } from "react";
import {
  Dialog,
  InputAdornment,
  TextField,
  FormControlLabel,
  Switch
} from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroller";
import { P_Props } from "./DocumentationList.type";
import { CategoryCard1, Loading, Notification, Pulse, UploadButton, CustomButton } from "../../../components";
import { DocumentStatus, DocumentFlag, DocumentOutputModel } from "../../../../models";
import { DocumentationForm } from "../..";
import {
  PriorityHigh as PriorityHighIcon,
  Search,
} from "@material-ui/icons";
import { DeleteIcon, PDFIcon, XLSXIcon, DOCXIcon } from "../../../icons";

const DocumentationListPresenter: React.FC<P_Props> = (props) => {
  const [visibleDeleteModal, setVisibleDeleteModal] = useState<boolean>(false);
  const [visibleWarningModal, setVisibleWarningModal] = useState<boolean>(false);

  const [visibleUploadFile, setVisibleUploadFile] = useState<boolean>(false);
  const [fileDelete, setFileDelete] = useState<DocumentOutputModel | undefined>();

  const toggleDeleteModal = (document) => {
    if (document) {
      setFileDelete(document)
    }
    setVisibleDeleteModal(!visibleDeleteModal);
  };

  const toggleWarningModal = () => {
    setVisibleWarningModal(!visibleWarningModal);
  };

  const category = [
    {
      id: "ABOUTUS",
      flag: DocumentFlag.ABOUTUS,
      name: "About Us",
      title: "About Us - Documents"
    },
    {
      id: "RESOURCE",
      flag: DocumentFlag.RESOURCE,
      name: "Resource",
      title: "Resource - Documents"
    },
    {
      id: "IMPORT",
      flag: DocumentFlag.IMPORT,
      name: "Import Document",
      title: "Import - Documents"
    },
    {
      id: "EXPORT",
      flag: DocumentFlag.EXPORT,
      name: "Export Document",
      title: "Export - Documents"
    },
  ]

  const activeCategory = category.find((cate) => cate.flag === props.filter.cateFlag);

  return (
    <>
      <div className="document-listing">
        <div className="document-listing__category">
          <div className="document-listing__category__header">
            <div className="title">Category</div>
          </div>
          <div className="document-listing__category__list">
            {category.map((cate) => {
              const isActive = cate.id === activeCategory?.id;

              return (
                <CategoryCard1
                  key={cate.id}
                  name={cate.name}
                  onClick={() => {
                    props.onChangeCategory(cate.id, cate.flag);
                  }}
                  selected={isActive}
                  isAvatar={false}
                />
              );
            })}
          </div>
        </div>

        <div className="document-listing__content">
          <div className="document-listing__content__header">
            <div className="document-listing__content__header__title">{activeCategory ? `${activeCategory?.title}`: "Documentation"}</div>
            <div className="document-listing__content__header__actions">
              <TextField
                placeholder="Search by name"
                variant="outlined"
                className="search-input"
                inputProps={{ className: "input" }}
                InputProps={{
                  // style: { fontSize: "1.4rem" },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search className="icon" />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  props.onSearch(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="document-listing__content__list">
            <InfiniteScroll
              useWindow={false}
              pageStart={1}
              initialLoad={false}
              hasMore={!props.fetchedDocument.loading && props.fetchedDocument.totalPages > props.fetchedDocument.page}
              loadMore={() => {
                props.onLoadMore();
              }}
            >
              {!Boolean(props.fetchedDocument.data.length) && props.fetchedDocument.loading && <Loading />}
              {props.fetchedDocument.data.map((doc) => {
                return (
                  <div key={doc.id} className="document-listing__content__list__item">
                    <div className="document-text document-listing__content__list__thumbnail">
                      {(doc.name.split('.').pop() === "pdf")
                        ? <PDFIcon size={[37, 49]} color="#E93C3C" />
                        : (doc.name.split('.').pop() === "docx" || doc.name.split('.').pop() === "doc")
                          ? <DOCXIcon size={[37, 49]} color="#439BCF" />
                          : (doc.name.split('.').pop() === "xlsx" || doc.name.split('.').pop() === "xls")
                            ? <XLSXIcon size={[37, 49]} color="#4EAA39" />
                            : ""
                      }
                    </div>
                    <div className="document-text document-listing__content__list__name">
                      {doc.name}
                    </div>
                    <div className="document-text document-listing__content__list__status">
                      <FormControlLabel
                        control={
                          <Switch
                            checked={Boolean(doc.status === DocumentStatus.PUBLISH)}
                            className="app-switch-box"
                            onChange={(e) => {
                              e.preventDefault();
                              props.handleChangeStatus(doc, doc.status);
                            }}
                          />
                        }
                        label={
                          <div className="document-text">
                            {Boolean(doc.status === DocumentStatus.PUBLISH) ? "Published" : "Not Publish"}
                          </div>
                        }
                      />
                    </div>
                    <div className="document-text document-listing__content__list__control">
                      <CustomButton 
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          toggleDeleteModal(doc);
                        }}
                        color={"transparent"}
                        item={
                          <span>
                            <DeleteIcon size={[20, 20]} viewBox={[20, 20]} color={"#272B2F"} />
                          </span>
                        }
                      />
                    </div>
                  </div>
                );
              })}
              {Boolean(props.fetchedDocument.data.length) && props.fetchedDocument.loading && <Loading />}
            </InfiniteScroll>
          </div>
        </div>
      </div>

      <UploadButton
        onClickPrimary={() => {
          if ((activeCategory?.flag === DocumentFlag.ABOUTUS || activeCategory?.flag === DocumentFlag.RESOURCE) && (props.fetchedDocument.data.length))
          {
            setVisibleWarningModal(true);
          }
          else {
            setVisibleUploadFile(true);
          }
        }}
      />

      {/* Upload Form */}
      <Dialog open={visibleUploadFile} maxWidth="sm" fullWidth>
        <DocumentationForm 
          flag={props.categoryFlag}
          documentList={props.allDocuments}
          onCancel={() => {
            setVisibleUploadFile(false);
            props.reloadListingPage();
          }}
          onComplete_Create={() => {
            setVisibleUploadFile(false);
            props.reloadListingPage();
          }}
        />
      </Dialog>

      {/* Form confirm delete */}
      <Notification
        visible={visibleDeleteModal}
        title="Delete file"
        subTitle={`Are you sure to delete file “${fileDelete?.name}“?`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="document-listing__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteModal(fileDelete);
              }}
            >
              Cancel
            </button>
            <button
              className="document-listing__delete-modal__actions__confirm"
              onClick={() => {
                toggleDeleteModal(fileDelete);
                if (fileDelete?.id)
                  props.onDeleteDocument(fileDelete.id);
              }}
            >
              Confirm
            </button>
          </>
        }
      />

      {/* Warning replace file */}
      <Notification
        visible={visibleWarningModal}
        title="Upload New File Notice"
        subTitle={`There is only 1 file that will be published on “About us”. Therefore new file will replace the existing one`}
        icon={
          <Pulse color={"yellow"}>
            <div className="notification-icon-box yellow">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="document-listing__status-modal__actions__cancel"
              onClick={() => {
                toggleWarningModal();
              }}
            >
              Cancel
            </button>
            <button
              className="document-listing__status-modal__actions__confirm"
              onClick={() => {
                toggleWarningModal();
                setVisibleUploadFile(true);
              }}
            >
              Confirm
            </button>
          </>
        }
      />
    </>
  );
};

export default DocumentationListPresenter;
